export const D2R = Math.PI / 180;
export const R2D = 180 / Math.PI;
